function account() {
  return {
    "type": "1",
    "taxIdNumber": undefined,
    "taxIdNumberFormatted": undefined,
    "person": {
      "birthDate": undefined,
      // Precisa nascer como string: com o model undefined, o updateDOMProps do Vue
      // cai no ramo `if (isUndef(props[key])) elm[key] = ""` e zera o input a cada
      // re-render, mesmo com ele em foco -- o campo se apagava ao ser digitado (Bug 406).
      "birthDateBR": "",
      "fullName": undefined,
      "name": undefined,
      "lastName": undefined
    },
    "accountAuthentication": {
      "login": undefined,
      "password": undefined,
      "confirmPassword": undefined,
      "active": "Y"
    },
    "nroCellphone": "",
    "dddCellphone": "",

    "typePhone": "RESIDENCIAL",
    "dddPhone": "",
    "nroPhone": "",

    "typePhone2": "COMERCIAL",
    "dddPhone2": "",
    "nroPhone2": "",


  }
};

function address() {
  return {
    "type": "MAILING",
    "number": undefined,
    "complement": undefined,
    "address": undefined,
    "neighborhood": undefined,
    "city": undefined,
    "state": undefined,
    "zipCode": undefined
  }
};



function contract() {
  return {
    "plan": {
      "planId": 21
    },
    "paymentMethods": {
      "paymentMethod": [{
        "priority": "1",
        "paymentMethodId": undefined
      }]
    },
    "rechargeValue": undefined,
    "changeFlagEmail": "0",
    "limitCredit": undefined,
    "lcFlag": undefined
  }
};

function payment() {
  return {
    "priority": "1",
    "paymentMethodId": undefined
  }
};


function businessActivity() {
  return [{
      id: "1",
      label: "Agricultura",
      value: "AGRICULTURA"
    },
    {
      id: "2",
      label: "Alimentos e Bebidas",
      value: "ALIMENTOS_E_BEBIDAS"
    },
    {
      id: "3",
      label: "Biotecnologia",
      value: "BIOTECNOLOGIA"
    },
    {
      id: "4",
      label: "Comunicações",
      value: "COMUNICACOES"
    },
    {
      id: "5",
      label: "Contrução Civil",
      value: "CONSTRUCAO_CIVIL"
    },
    {
      id: "6",
      label: "Consultoria",
      value: "CONSULTORIA"
    },
    {
      id: "7",
      label: "Educação",
      value: "EDUCACAO"
    },
    {
      id: "8",
      label: "Eletrônica",
      value: "ELETRONICA"
    },
    {
      id: "9",
      label: "Energia",
      value: "ENERGIA"
    },
    {
      id: "10",
      label: "Engenharia",
      value: "ENGENHARIA"
    },
    {
      id: "11",
      label: "Entretenimento",
      value: "ENTRETENIMENTO"
    },
    {
      id: "12",
      label: "Equipamentos",
      value: "EQUIPAMENTOS"
    },
    {
      id: "13",
      label: "Expedição",
      value: "EXPEDICAO"
    },
    {
      id: "14",
      label: "Finanças",
      value: "FINANCAS"
    },
    {
      id: "15",
      label: "Governo",
      value: "GOVERNO"
    },
    {
      id: "16",
      label: "Hotelaria",
      value: "HOTELARIA"
    },
    {
      id: "17",
      label: "Manufatura",
      value: "MANUFATURA"
    },
    {
      id: "18",
      label: "Meio Ambiente",
      value: "MEIO_AMBIENTE"
    },
    {
      id: "19",
      label: "Mídia",
      value: "MIDIA"
    },
    {
      id: "20",
      label: "Produtos Químicos",
      value: "PRODUTOS_QUIMICOS"
    },
    {
      id: "21",
      label: "Recreação",
      value: "RECREACAO"
    },
    {
      id: "22",
      label: "Saúde",
      value: "SAUDE"
    },
    {
      id: "23",
      label: "Seguros",
      value: "SEGUROS"
    },
    {
      id: "24",
      label: "Sem fins lucrativos",
      value: "SEM_FINS_LUCRATIVOS"
    },
    {
      id: "25",
      label: "Serviços bancários",
      value: "SERVICOS_BANCARIOS"
    },
    {
      id: "26",
      label: "Serviços públicos",
      value: "SERVICOS_PUBLICOS"
    },
    {
      id: "27",
      label: "Tecnologia",
      value: "TECNOLOGIA"
    },
    {
      id: "28",
      label: "Telecomunicações",
      value: "TELECOMUNICACOES"
    },
    {
      id: "29",
      label: "Transporte",
      value: "TRANSPORTE"
    },
    {
      id: "30",
      label: "Outras",
      value: "OUTRAS"
    }
  ]
};

function vehicle() {
  return {
    "plate": "",
    "enabled": "",
    "isTransportador": false,
    "cpfCnpjTransportador": undefined,
    "categoryAxes": {
      "categoryAxesId": 1,
      "name": "AUTOMÓVEIS"
    },
    "model": {
      "modelId": "",
      "name": "",
      "brand": {
        "brandId": "",
        "name": ""
      },
      "categoryAxes": {
        "categoryAxesId": "1",
        "name": "2 eixos, rodagem simples"
      }
    },
  };
}

function states() {
  return [{
      "id": "1",
      "sigla": "AC",
      "name": "Acre"
    },
    {
      "id": "2",
      "sigla": "AL",
      "name": "Alagoas"
    },
    {
      "id": "3",
      "sigla": "AM",
      "name": "Amazonas"
    },
    {
      "id": "4",
      "sigla": "AP",
      "name": "Amapá"
    },
    {
      "id": "5",
      "sigla": "BA",
      "name": "Bahia"
    },
    {
      "id": "6",
      "sigla": "CE",
      "name": "Ceará"
    },
    {
      "id": "7",
      "sigla": "DF",
      "name": "Distrito Federal"
    },
    {
      "id": "8",
      "sigla": "ES",
      "name": "Espírito Santo"
    },
    {
      "id": "9",
      "sigla": "GO",
      "name": "Goiás"
    },
    {
      "id": "10",
      "sigla": "MA",
      "name": "Maranhão"
    },
    {
      "id": "11",
      "sigla": "MG",
      "name": "Minas Gerais"
    },
    {
      "id": "12",
      "sigla": "MS",
      "name": "Mato Grosso do Sul"
    },
    {
      "id": "13",
      "sigla": "MT",
      "name": "Mato Grosso"
    },
    {
      "id": "14",
      "sigla": "PA",
      "name": "Pará"
    },
    {
      "id": "15",
      "sigla": "PB",
      "name": "Paraíba"
    },
    {
      "id": "16",
      "sigla": "PE",
      "name": "Pernambuco"
    },
    {
      "id": "17",
      "sigla": "PI",
      "name": "Piauí"
    },
    {
      "id": "18",
      "sigla": "PR",
      "name": "Paraná"
    },
    {
      "id": "19",
      "sigla": "RJ",
      "name": "Rio de Janeiro"
    },
    {
      "id": "20",
      "sigla": "RN",
      "name": "Rio Grande do Norte"
    },
    {
      "id": "21",
      "sigla": "RO",
      "name": "Rondônia"
    },
    {
      "id": "22",
      "sigla": "RR",
      "name": "Roraima"
    },
    {
      "id": "23",
      "sigla": "RS",
      "name": "Rio Grande do Sul"
    },
    {
      "id": "24",
      "sigla": "SC",
      "name": "Santa Catarina"
    },
    {
      "id": "25",
      "sigla": "SE",
      "name": "Sergipe"
    },
    {
      "id": "26",
      "sigla": "SP",
      "name": "São Paulo"
    },
    {
      "id": "27",
      "sigla": "TO",
      "name": "Tocantins"
    }
  ]
};

function companyAccount() {
  return {
    type: "2",
    company: {},
    accountAuthentication: {
      "active": "Y"
    },
    "nroCellphone": "",
    "dddCellphone": "",

    "typePhone": "COMERCIAL",
    "dddPhone": "",
    "nroPhone": "",

    "typePhone2": "COMERCIAL",
    "dddPhone2": "",
    "nroPhone2": "",
  };
}
export {
  account,
  address,
  contract,
  payment,
  businessActivity,
  states,
  companyAccount,
  vehicle
}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/objects.js